/*******  MINI CART — PERFORMANCE + REWARD1/2/3 (UNIFIED, ES5-SAFE + DIAGNOSTICS) *******/

/* ===== 0) LOG TOGGLE ===== */
var JCR_DEBUG = false;   // your normal lightweight logs
var JCR_TRACE = false;   // extra diagnostics — set to false when done

function jlog(level) {
  if (!JCR_DEBUG) return;
  var args = Array.prototype.slice.call(arguments, 1);
  (console[level] || console.log).apply(console, ['[JCR]'].concat(args));
}
function jtrace() {
  if (!JCR_TRACE) return;
  var args = Array.prototype.slice.call(arguments);
  console.log.apply(console, ['[JCR:TRACE]'].concat(args));
}

/* ===== 1) SINGLETON CART FETCH + DEBOUNCE ===== */
var __jcrRefreshTimer = null;
var __jcrCartFetchInFlight = null;

function jcrDebouncedRefresh(delay) {
  if (typeof delay !== 'number') delay = 100;
  if (__jcrRefreshTimer) cancelAnimationFrame(__jcrRefreshTimer);
  __jcrRefreshTimer = requestAnimationFrame(function () {
    setTimeout(function () { refreshBar(); }, delay);
  }); 
}

function jcrGetCart() {
  if (__jcrCartFetchInFlight) return __jcrCartFetchInFlight;
  __jcrCartFetchInFlight = fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .catch(function (err) { jlog('error', 'GET /cart.js failed', err); throw err; })
    .finally(function () { __jcrCartFetchInFlight = null; });
  return __jcrCartFetchInFlight;
}

/* ===== small helpers ===== */
function jcrGetData(el, key, fallback) {
  if (!el || !el.dataset) return (fallback == null ? '' : fallback);
  var v = el.dataset[key];
  return (v == null ? (fallback == null ? '' : fallback) : v);
}

function jcrGetTierAuto(key) {
  // key = 'reward1' | 'reward2' | 'reward3'
  var c = document.querySelector('.j_cr-container');
  if (!c || !c.dataset) return true; // default to safe/strict
  var raw = String(c.dataset[key + 'Auto'] || '').toLowerCase();
  return raw === 'true' || raw === '1';
}

function jcrIsTierLineWithFlag(flagName) {
  return function(item) {
    var p = (item && item.properties) || {};
    var v = p[flagName];
    return v === 1 || v === '1' || v === true || v === 'true';
  };
}

function jcrCollectFlaggedKeysByFlag(cart, flagName) {
  var pred = jcrIsTierLineWithFlag(flagName);
  var out = [];
  (cart.items || []).forEach(function(i){ if (pred(i) && i.key) out.push(i.key); });
  return out;
}

function jcrRemoveTierItems(cart, flagName, sourceTag) {
  var keys = jcrCollectFlaggedKeysByFlag(cart, flagName);
  if (!keys.length) return Promise.resolve();

  return jcrRemoveByKeys(keys)
    .then(function(){ return jcrGetCart().catch(function(){ return null; }); })
    .then(function(latest){
      if (!latest) return;
      var remaining = jcrCollectFlaggedKeysByFlag(latest, flagName);
      if (remaining.length) return jcrRemoveByKeys(remaining);
    })
    .then(function(){
      jcrEmitCartSignals({ removed: flagName, count: keys.length, source: sourceTag || 'jcrRemoveTierItems' });
      document.dispatchEvent(new Event('cart:updated'));
    });
}


/* ===== 2) CACHE CONFIG/REWARDS + DOM REFS ===== */
var jcrRefs = {
  container: null,
  bar: null,
  markersHost: null,
  labelsHost: null,
  unlockR1: null,
  unlockR2: null,
  unlockR3: null,
  cfg: null,
  reward1Data: null,
  reward2Data: null,
  reward3Data: null
};

function jcrParseJSONAttr(el, attr) {
  if (!el || !el.dataset) return [];
  var raw = el.dataset[attr];
  if (!raw) return [];
  try { return JSON.parse(raw); }
  catch (e) { jlog('error', 'data-' + attr + ' parse failed', e, raw); return []; }
}

function jcrInitRefs(force) {
  if (jcrRefs.container && force !== true) {
    try { if (document.body.contains(jcrRefs.container)) return; } catch (_) {}
  }

  jcrRefs.container  = document.querySelector('.j_cr-container') || null;
  jcrRefs.bar        = document.getElementById('j_cr-progress-bar') || null;
  if (!jcrRefs.container || !jcrRefs.bar) return;

  jcrRefs.markersHost = jcrRefs.bar.querySelector('.j_cr-markers') || null;
  jcrRefs.labelsHost  = jcrRefs.container.querySelector('.j_cr-labels') || null;

  // IDs (new)
  jcrRefs.unlockR1 = document.getElementById('j_cr-reward1-unlock') || null;
  jcrRefs.unlockR2 = document.getElementById('j_cr-reward2-unlock') || null;
  jcrRefs.unlockR3 = document.getElementById('j_cr-reward3-unlock') || null;

  // payloads
  jcrRefs.cfg         = jcrParseJSONAttr(jcrRefs.container, 'config');
  jcrRefs.reward1Data = jcrParseJSONAttr(jcrRefs.container, 'reward1');
  jcrRefs.reward2Data = jcrParseJSONAttr(jcrRefs.container, 'reward2');
  jcrRefs.reward3Data = jcrParseJSONAttr(jcrRefs.container, 'reward3');

  jtrace('initRefs: cfg len=', (jcrRefs.cfg||[]).length,
         'r1 len=', (jcrRefs.reward1Data||[]).length,
         'r2 len=', (jcrRefs.reward2Data||[]).length,
         'r3 len=', (jcrRefs.reward3Data||[]).length,
         'unlockR1?', !!jcrRefs.unlockR1, 'unlockR2?', !!jcrRefs.unlockR2, 'unlockR3?', !!jcrRefs.unlockR3);
}

function jcrGetCfgAndRewardsCached() {
  jcrInitRefs();
  return {
    cfg: jcrRefs.cfg || [],
    r1: jcrRefs.reward1Data || [],
    r2: jcrRefs.reward2Data || [],
    r3: jcrRefs.reward3Data || []
  };
}

/* ===== 3) MONEY + REWARD1 META HELPERS ===== */
function jcrGetCurrencyMeta() {
  var c = document.querySelector('.j_cr-container');
  var code = jcrGetData(c, 'currencyCode', 'USD').toUpperCase();
  var symbol = jcrGetData(c, 'currencySymbol', '$');
  var zero = { JPY:1, KRW:1, VND:1 };
  var divisor = zero[code] ? 1 : 100;
  return { code: code, symbol: symbol, divisor: divisor };
}
function jcrFormatMoney(cents) {
  var n = Number(cents || 0);
  var cur = jcrGetCurrencyMeta();
  var value = n / cur.divisor;
  return cur.symbol + (cur.divisor === 1 ? Math.round(value).toString() : value.toFixed(2));
}
function jcrFormatMoneyShort(cents) {
  var n = Number(cents || 0);
  var cur = jcrGetCurrencyMeta();
  var value = n / cur.divisor;
  return cur.symbol + Math.round(value).toString();
}
function jcrDiscountedCents(priceCents, percent) {
  var p = Math.max(0, Math.min(100, Number(percent || 0)));
  return Math.round((Number(priceCents || 0)) * (100 - p) / 100);
}

function jcrGetReward1Meta() {
  var c = document.querySelector('.j_cr-container');
  if (!c || !c.dataset) return { percent: 0, text: '', auto: false, code: '' };
  var percent = parseFloat(c.dataset.reward1Percent || '0') || 0;
  var text    = c.dataset.reward1Text || '';
  var autoStr = String(c.dataset.reward1Auto || '').toLowerCase();
  var code    = c.dataset.reward1Code || '';
  var isAuto  = (autoStr === 'true' || autoStr === '1');
  return { percent: isAuto ? 0 : percent, text: text, auto: isAuto, code: code };
}

function jcrRenderMessage(tpl, productTitle, origCents, finalCents, percent, compareAtCents) {
  if (!tpl) return '';
  var hasCompare = Number(compareAtCents) > 0 && Number(compareAtCents) > Number(finalCents || 0);
  var showPair = hasCompare || (percent > 0 && Number(finalCents) < Number(origCents));
  var priceHTML = showPair
    ? '<span class="j_cr-price-orig">' + jcrFormatMoney(hasCompare ? compareAtCents : origCents) + '</span> <span class="j_cr-price-disc">' + jcrFormatMoney(finalCents) + '</span>'
    : '<span class="j_cr-price-disc">' + jcrFormatMoney(finalCents || origCents) + '</span>';
  return tpl.replace(/%product%/gi, String(productTitle || '')).replace(/%price%/gi, priceHTML);
}

function jcrSetFillScale(el, pct) { if (!el) return; requestAnimationFrame(function () { el.style.transform = 'scaleX(' + (pct / 100) + ')'; }); }

/* ===== SUBTOTAL EXCLUDING ALL REWARD LINES ===== */
function jcrIsReward1Line(item) {
  if (!item) return false;
  var p = item.properties || {};
  if (p._reward1 === 1 || p._reward1 === '1' || p._reward1 === true || p._reward1 === 'true') return true;
  if (p._mystery === 1 || p._mystery === '1' || p._mystery === true || p._mystery === 'true') return true; // legacy
  if (p.mystery === 1 || p.mystery === '1' || p.mystery === true || p.mystery === 'true') return true;     // legacy
  return false;
}
function jcrIsReward2or3Line(item) {
  if (!item) return false;
  var p = item.properties || {};
  if (p._reward2 === 1 || p._reward2 === '1' || p._reward2 === true || p._reward2 === 'true') return true;
  if (p._reward3 === 1 || p._reward3 === '1' || p._reward3 === true || p._reward3 === 'true') return true;
  if (p._premium === 1 || p._premium === '1' || p._premium === true || p._premium === 'true') return true; // legacy
  return false;
}
function jcrIsPromoLine(item) { return jcrIsReward1Line(item) || jcrIsReward2or3Line(item); }

function jcrCollectFlaggedKeys(cart, predicate) {
  var out = [];
  (cart.items || []).forEach(function (i) {
    if (predicate(i) && i.key) out.push(i.key);
  });
  return out;
}

function jcrGetSpendSubtotal(cart) {
  var sum = 0;
  (cart.items || []).forEach(function (i) {
    if (jcrIsPromoLine(i)) return;
    var lp = (i.line_price != null) ? Number(i.line_price) : (Number(i.price || 0) * Number(i.quantity || 1));
    sum += lp;
  });
  return sum;
}

var __jcrMarkerState = {}; // keys: free_shipping | reward1 | reward2 | reward3

/* ===== 4) PROGRESS BAR ===== */
function jcrBuildUIFromConfig() {
  var bar = jcrRefs.bar;
  if (!bar) return;
  var cfg = jcrRefs.cfg || [];
  var markersHost = jcrRefs.markersHost;
  var labelsHost  = jcrRefs.labelsHost;
  if (!markersHost || !labelsHost) return;

  markersHost.innerHTML = '';
  labelsHost.innerHTML  = '';

  if (!cfg.length) {
    bar.style.display = 'none';
    return;
  }

  var positions = (cfg.length === 4) ? [20, 45, 70, 90]
                : (cfg.length === 3) ? [25, 55, 85]
                : (cfg.length === 2) ? [30, 80]
                : [50];

  var mdDefault = jcrGetData(jcrRefs.container, 'mdDefault', '');
  var mdMet     = jcrGetData(jcrRefs.container, 'mdMet', '');
  var pdDefault = jcrGetData(jcrRefs.container, 'pdDefault', '');
  var pdMet     = jcrGetData(jcrRefs.container, 'pdMet', '');
  var fsMet     = jcrGetData(jcrRefs.container, 'fsMet', '');

  for (var i = 0; i < cfg.length; i++) {
    var item = cfg[i] || {};
    var pos = positions[i] || 50;
    var key = String(item.key || '');
    var startState = __jcrMarkerState[key] || 'default';

    var m = document.createElement('div');
    m.className = 'j_cr-marker';
    m.dataset.threshold = String(item.amount || 0);
    m.dataset.pos = String(pos);
    m.dataset.key = key;
    m.dataset.state = startState;

    if (key === 'free_shipping') {
      var amt = document.createElement('span');
      amt.className = 'j_cr-dot j_cr-amt';
      amt.textContent = jcrFormatMoneyShort(item.amount || 0);

      var img = document.createElement('img');
      img.className = 'j_cr-dot j_cr-icon';
      img.src = fsMet || '';
      img.setAttribute('data-met-icon', img.src);
      img.style.display = (startState === 'met') ? '' : 'none';
      img.setAttribute('width', '24');
      img.setAttribute('height', '24');

      if (startState === 'met') {
        m.classList.add('is-reached');
        amt.style.display = 'none';
      }

      m.appendChild(amt);
      m.appendChild(img);
    } else {
      var icon = document.createElement('img');
      icon.className = 'j_cr-dot j_cr-icon';
      icon.setAttribute('width', '24');
      icon.setAttribute('height', '24');

      if (key === 'reward1') {
        icon.setAttribute('data-default-icon', mdDefault || '');
        icon.setAttribute('data-met-icon', mdMet || '');
      } else {
        icon.setAttribute('data-default-icon', pdDefault || '');
        icon.setAttribute('data-met-icon', pdMet || '');
      }

      icon.src = (startState === 'met' ? icon.getAttribute('data-met-icon') : icon.getAttribute('data-default-icon')) || '';
      m.appendChild(icon);
    }

    markersHost.appendChild(m);

    var lab = document.createElement('div');
    lab.className = 'j_cr-label';
    lab.dataset.pos = String(pos);
    lab.textContent = String(item.label || '');
    labelsHost.appendChild(lab);
  }

  jcrPositionMarkers(bar);
}

function jcrPositionMarkers(bar) {
  var ms = bar.querySelectorAll('.j_cr-marker');
  for (var i = 0; i < ms.length; i++) ms[i].style.left = (ms[i].dataset.pos || '0') + '%';
  var ls = (bar.closest('.j_cr-container') || document).querySelectorAll('.j_cr-label');
  for (var j = 0; j < ls.length; j++) ls[j].style.left = (ls[j].dataset.pos || '0') + '%';
}

function jcrComputeFillPct(total, marks) {
  if (!marks || !marks.length) return 0;
  marks = marks.slice().sort(function (a, b) { return Number(a.pos) - Number(b.pos); });
  if (total <= marks[0].t) return (total / Math.max(1, marks[0].t)) * Number(marks[0].pos);
  for (var i = 0; i < marks.length - 1; i++) {
    var a = marks[i], b = marks[i + 1];
    if (total <= b.t) {
      var span = Math.max(1, b.t - a.t);
      var segProgress = (total - a.t) / span;
      var segWidth = Number(b.pos) - Number(a.pos);
      return Number(a.pos) + segWidth * segProgress;
    }
  }
  return 100;
}

/* ===== 5) A11Y SHOW/HIDE ===== */
function jcrSetInert(el, value) { if (!el) return; try { el.inert = !!value; } catch (e) {} if (value) el.setAttribute('inert', ''); else el.removeAttribute('inert'); }
function jcrFocusSafeTarget() {
  var safe = document.querySelector('[data-minicart-close]') || document.querySelector('#mini-cart,[role="dialog"]') || document.body;
  if (safe && safe.focus) { if (!safe.hasAttribute('tabindex')) safe.setAttribute('tabindex', '-1'); safe.focus(); }
}
function jcrHideSection(el) { if (!el) return; if (el.contains(document.activeElement)) jcrFocusSafeTarget(); jcrSetInert(el, true); el.classList.add('is-hidden'); el.setAttribute('hidden', ''); el.setAttribute('aria-hidden', 'true'); }
function jcrShowSection(el) { if (!el) return; jcrSetInert(el, false); el.classList.remove('is-hidden'); el.removeAttribute('hidden'); el.setAttribute('aria-hidden', 'false'); }

/* ===== LABEL RENDER for reward2/3 ===== */
function jcrRenderPremiumLabelFor(el, tpl, p) {
  if (!el) return;
  var lab = el.querySelector('.j_cr-reward2-msg, .j_cr-reward3-msg, .j_cr-premium-label');
  if (!lab) return;

  if (!tpl) { lab.textContent = ''; return; }
  var finalPrice = p ? jcrFormatMoney(p.price) : '';
  var out = tpl
    .replace(/%product%/gi, p ? String(p.title || '') : '')
    .replace(/%price%/gi, finalPrice);
  lab.innerHTML = out;
}

/* ===== 6) CART PREDICATES + SKU HELPERS ===== */
function jcrCartHasProduct(cart, prod) {
  if (!prod) return false;
  var vid    = String(prod.variant_id || '');
  var handle = String(prod.handle || '').toLowerCase();
  var sku    = String(prod.sku || '').trim().toLowerCase();

  return (cart.items || []).some(function (i) {
    if (jcrIsPromoLine(i)) return false;
    var vmatch   = vid && String(i.variant_id) === vid;
    var hmatch   = handle && String(i.handle || '').toLowerCase() === handle;
    var skuMatch = sku && String(i.sku || '').trim().toLowerCase() === sku;
    return vmatch || hmatch || skuMatch;
  });
}

var __jcrProductSkuCache = {};
function jcrBuildCartSkuSet(cart) {
  var map = {};
  (cart.items || []).forEach(function (i) {
    if (jcrIsPromoLine(i)) return;
    var sku = (i.sku || '').trim().toLowerCase();
    if (sku) map[sku] = true;
  });
  return map;
}
function jcrMapHas(mapObj, key) { return !!mapObj[key]; }

function jcrGetAllVariantSkusForHandle(handle) {
  var h = String(handle || '').toLowerCase();
  if (!h) return Promise.resolve([]);
  if (__jcrProductSkuCache[h]) return Promise.resolve(__jcrProductSkuCache[h]);

  return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
    .then(function (res) { return res.json(); })
    .then(function (prod) {
      var skus = Array.isArray(prod && prod.variants)
        ? prod.variants.map(function (v) { return String(v.sku || '').trim().toLowerCase(); }).filter(Boolean)
        : [];
      __jcrProductSkuCache[h] = skus;
      return skus;
    })
    .catch(function () { __jcrProductSkuCache[h] = []; return []; });
}

/* ===== 6a) Unified Offer Type Map ===== */
var JCR_OFFERS = {
  reward1: {
    key: 'reward1',
    flag: '_reward1',
    isFree: false,
    unlockId: 'j_cr-reward1-unlock',
    cardId: 'j_cr-reward1-card',
    msgClass: '.j_cr-reward1-msg',
    wrapClass: '.j_cr-reward1-variant-wrap',
    btnClass:  '.j_cart-upsell__quickadd',
    propPayload: { _reward1: '1', _source: 'minicart' }
  },
  reward2: {
    key: 'reward2',
    flag: '_reward2',
    isFree: true,
    unlockId: 'j_cr-reward2-unlock',
    cardId: 'j_cr-reward2-card',
    msgClass: '.j_cr-reward2-msg',
    wrapClass: '.j_cr-reward2-variant-wrap',
    btnClass:  '.j_cart-upsell__quickadd',
    propPayload: { _reward2: '1', _source: 'minicart' }
  },
  reward3: {
    key: 'reward3',
    flag: '_reward3',
    isFree: true,
    unlockId: 'j_cr-reward3-unlock',
    cardId: 'j_cr-reward3-card',
    msgClass: '.j_cr-reward3-msg',
    wrapClass: '.j_cr-reward3-variant-wrap',
    btnClass:  '.j_cart-upsell__quickadd',
    propPayload: { _reward3: '1', _source: 'minicart' }
  }
};

/* ===== robust normalizer (accepts string/object, tolerant fields) ===== */
function jcrNormalizeOfferList(list) {
  if (!Array.isArray(list)) return [];
  var out = [];
  var seen = {};

  function coerce(item, idx, tier) {
    // allow strings: treat as a handle
    if (typeof item === 'string') {
      return { key: (tier || 'r') + '_' + idx, handle: String(item).toLowerCase() };
    }

    // unwrap common nested shapes
    var p = item && item.product ? item.product : item;

    // try several property names
    var handle = '';
    if (p) {
      handle = String(
        p.handle ||
        p.product_handle ||
        (p.url && typeof p.url === 'string' ? p.url.replace(/^.*\/products\//, '').replace(/\/.*$/, '') : '') ||
        ''
      ).toLowerCase();
    }

    var vid = '';
    if (p) {
      vid = String(
        p.variant_id ||
        (p.selected_or_first_available_variant && p.selected_or_first_available_variant.id) ||
        p.id || ''
      );
    }

    var sku = '';
    if (p) {
      sku = String(
        p.sku ||
        (p.selected_or_first_available_variant && p.selected_or_first_available_variant.sku) ||
        ''
      ).trim().toLowerCase();
    }

    // if we literally have none of the 3 pivots, keep a trace + skip
    if (!handle && !vid && !sku) {
      jlog('warn', '[JCR:TRACE] normalize skip — no handle/variant_id/sku', { idx: idx, raw: item });
      return null;
    }

    return {
      key: p && p.key || ((tier || 'r') + '_' + idx),
      handle: handle,
      title: p && (p.title || ''),
      variant_id: vid,
      sku: sku,
      image: p && (p.image || p.featured_image || ''),
      price: Number(p && (p.price || (p.selected_or_first_available_variant && p.selected_or_first_available_variant.price) || 0)),
      compare_at_price: Number(p && (p.compare_at_price || (p.selected_or_first_available_variant && p.selected_or_first_available_variant.compare_at_price) || 0))
    };
  }

  for (var i = 0; i < list.length; i++) {
    var coerced = coerce(list[i], i, 't');
    if (!coerced) continue;

    var dedupeKey = (coerced.handle || '-') + '|' + (coerced.sku || '-') + '|' + (coerced.variant_id || '-');
    if (seen[dedupeKey]) {
      jlog('info', '[JCR:TRACE] normalize dedupe', dedupeKey);
      continue;
    }
    seen[dedupeKey] = true;
    out.push(coerced);
  }

  jlog('info', '[JCR:TRACE] normalize result len=', out.length, 'sample=', out.slice(0, 2));
  return out;
}



function jcrPickOffer(cart, list, typeKey, allowCollision) {
  var t = JCR_OFFERS[typeKey];
  if (!t) return Promise.resolve({ pick: null, anyFlaggedInCart: false });
  if (!Array.isArray(list) || !list.length) return Promise.resolve({ pick: null, anyFlaggedInCart: false });

  var anyFlaggedInCart = (cart.items || []).some(function (i) {
    var p = i.properties || {};
    return p && (p[t.flag] === 1 || p[t.flag] === '1' || p[t.flag] === true || p[t.flag] === 'true');
  });
  if (anyFlaggedInCart) return Promise.resolve({ pick: null, anyFlaggedInCart: true });

  var cartSkuMap = jcrBuildCartSkuSet(cart);
  var idx = 0;

  function next() {
    if (idx >= list.length) return Promise.resolve({ pick: null, anyFlaggedInCart: false });
    var cand = list[idx++]; if (!cand) return next();

    var handle  = String(cand.handle || '').toLowerCase();
    var candSku = String(cand.sku || '').trim().toLowerCase();

    return jcrGetAllVariantSkusForHandle(handle).then(function (variantSkus) {
      variantSkus = Array.isArray(variantSkus) ? variantSkus : [];
      var family = {};
      if (candSku) family[candSku] = true;
      for (var k = 0; k < variantSkus.length; k++) family[variantSkus[k]] = true;

      if (allowCollision) {
        // Do NOT suppress if same SKU exists in cart
        return { pick: cand, anyFlaggedInCart: false };
      }

      // Strict mode: suppress if same SKU family already paid in cart
      var hasPaidCollision = false;
      for (var s in family) { if (jcrMapHas(cartSkuMap, s)) { hasPaidCollision = true; break; } }
      var alreadyAsPaidProduct = jcrCartHasProduct(cart, cand);

      if (!hasPaidCollision && !alreadyAsPaidProduct) return { pick: cand, anyFlaggedInCart: false };
      return next();
    });
  }
  return next();
}


/* Thin wrappers */
function jcrPickReward1(cart, list){ return jcrPickOffer(cart, list, 'reward1'); }
function jcrPickReward2(cart, list){ return jcrPickOffer(cart, list, 'reward2'); }
function jcrPickReward3(cart, list){ return jcrPickOffer(cart, list, 'reward3'); }

/* ===== 7) QUICK ADD ===== */
function jcrEnsurePropsOnForm(btn, props) {
  var form = btn.closest('form');
  if (!form) return false;
  var idInput = form.querySelector('input[name="id"]');
  var vid = btn.dataset.variantId || (idInput && idInput.value);
  if (vid && !idInput) {
    var idInp = document.createElement('input');
    idInp.type = 'hidden'; idInp.name = 'id'; idInp.value = String(vid);
    form.appendChild(idInp);
  }
  for (var k in (props || {})) {
    if (!props.hasOwnProperty(k)) continue;
    var name = 'properties[' + k + ']';
    var inp = form.querySelector('input[name="' + name + '"]') || document.createElement('input');
    inp.type = 'hidden'; inp.name = name; inp.value = String(props[k]);
    if (!inp.parentNode) form.appendChild(inp);
  }
  return true;
}

function jcrEmitCartSignals(detail) {
  var names = ['cart:updated','cart:change','cart:refresh','ajaxProduct:added','added.ajaxProduct','t4s:cart:updated','t4s:cart:change'];
  names.forEach(function (name) {
    try {
      var e = new CustomEvent(name, { detail: detail });
      document.dispatchEvent(e); window.dispatchEvent(e);
    } catch (_) {
      var e2 = document.createEvent('Event');
      e2.initEvent(name, true, true);
      document.dispatchEvent(e2); window.dispatchEvent(e2);
    }
  });
}

function jcrManualAddWithProps(variantId, props) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ id: String(variantId), quantity: 1, properties: Object.assign({ _source: 'minicart' }, props || {}) })
  }).then(function(res){
    return res.text().then(function(text){
      var json = null; try { json = JSON.parse(text); } catch(_) {}
      if (!res.ok) throw new Error('Add failed: ' + res.status);
      jcrEmitCartSignals({ added: json, source: 'jcrManualAddWithProps' });
      return json;
    });
  });
}

/* ===== 8) VARIANT HYDRATION + CARD RENDER ===== */
function jcrHydrateVariantSelect(p, wrap, btn, msgEl) {
  if (!wrap || !btn) return Promise.resolve();

  var meta = jcrGetReward1Meta();

  function renderForVariant(v) {
    if (!v) return;
    btn.dataset.variantId = String(v.id);
    var finalPrice  = meta.auto ? Number(v.price) : jcrDiscountedCents(v.price, meta.percent);
    var compareAt   = meta.auto ? Number(v.compare_at_price || 0) : Number(v.price);
    if (msgEl) {
      msgEl.innerHTML = jcrRenderMessage(meta.text, p.title, Number(v.price), finalPrice, meta.percent, compareAt);
    }
    if (!btn.dataset.properties) btn.dataset.properties = JSON.stringify({ _reward1: '1', _source: 'minicart' });
    var formEl = btn.closest('form');
    var formId = formEl && formEl.querySelector('input[name="id"]');
    if (formId) formId.value = String(v.id);
  }

  function fallbackNoVariants() {
    var finalPrice = meta.auto ? Number(p.price) : jcrDiscountedCents(p.price, meta.percent);
    var compareAt  = meta.auto ? Number(p.compare_at_price || 0) : Number(p.price);
    if (msgEl) msgEl.innerHTML = jcrRenderMessage(meta.text, p.title, Number(p.price), finalPrice, meta.percent, compareAt);
    if (!btn.dataset.properties) btn.dataset.properties = JSON.stringify({ _reward1: '1', _source: 'minicart' });
    btn.dataset.variantId = String(p.variant_id || '');
  }

  if (!p.handle) { fallbackNoVariants(); return Promise.resolve(); }

  return fetch('/products/' + encodeURIComponent(p.handle) + '.js', { credentials: 'same-origin' })
    .then(function (res) { return res.json(); })
    .then(function (prod) {
      var variants = (prod && prod.variants && prod.variants.length)
        ? prod.variants.filter(function (v) { return v && v.available; })
        : [];

      // No available variants → nothing to offer safely
      if (!variants.length) { fallbackNoVariants(); return; }

      var defaultId = String(p.variant_id || variants[0].id);

      var sel = wrap.querySelector('select.j_cr-reward1-variant');
      if (!sel && variants.length > 1) {
        sel = document.createElement('select');
        sel.className = 'j_cr-reward1-variant j_cart-upsell__variant';
        wrap.appendChild(sel);
      }

      if (variants.length > 1 && sel) {
        while (sel.firstChild) sel.removeChild(sel.firstChild);
        variants.forEach(function (v) {
          var opt = document.createElement('option');
          opt.value = String(v.id);
          opt.textContent = v.title;
          sel.appendChild(opt);
        });
        sel.value = defaultId;
        var initial = null;
        for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === defaultId) { initial = variants[i]; break; } }
        if (!initial) initial = variants[0];
        renderForVariant(initial);
        sel.onchange = function () {
          var chosen = variants[0];
          for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(sel.value)) { chosen = variants[i]; break; } }
          renderForVariant(chosen);
        };
      } else {
        renderForVariant(variants[0]);
      }
    })
    .catch(function () { fallbackNoVariants(); });
}

/* Card render/hydrate/show — works for reward1/2/3 */
function jcrRenderOfferCard(typeKey, p) {
  var t = JCR_OFFERS[typeKey];
  var unlock = document.getElementById(t.unlockId);
  if (!unlock) return;

  var host = unlock.querySelector('#' + t.cardId) || unlock;
  var isR1 = (typeKey === 'reward1');
  var imgClass = isR1 ? 'j_cr-reward1-img' : (typeKey === 'reward2' ? 'j_cr-reward2-img' : 'j_cr-reward3-img');
  var msgCls = t.msgClass.slice(1);
  var wrapCls = t.wrapClass.slice(1);

  host.innerHTML = ''
    + '<div class="' + t.cardId.replace(/-/g,' ') + '" id="' + t.cardId + '">'
    +   (p && p.image ? '<img class="' + imgClass + ' j_cart-upsell__img" src="' + p.image + '" alt="' + (p.title || '') + '" width="300" height="300" />'
                      : '<img class="' + imgClass + ' j_cart-upsell__img" alt="" width="300" height="300" />')
    +   '<div class="' + (isR1 ? 'j_cr-reward1-body' : (typeKey === 'reward2' ? 'j_cr-reward2-body' : 'j_cr-reward3-body')) + '">'
    +     '<div class="' + (isR1 ? 'j_cr-reward1-info' : (typeKey === 'reward2' ? 'j_cr-reward2-info' : 'j_cr-reward3-info')) + '">'
    +       '<div class="' + msgCls + ' j_cart-upsell__title"></div>'
    +     '</div>'
    +     '<div class="' + (isR1 ? 'j_cr-reward1-actions' : (typeKey === 'reward2' ? 'j_cr-reward2-actions' : 'j_cr-reward3-actions')) + '">'
    +       '<div class="' + wrapCls + '"></div>'
    +       (p && p.variant_id
            ? '<button type="button" class="j_cart-upsell__quickadd t4s-btn" data-action-atc data-variant-id="' + p.variant_id + '" data-properties=\'' + JSON.stringify(t.propPayload) + '\'>' + (isR1 ? 'Quick Add' : 'ADD GIFT') + '</button>'
            : '')
    +     '</div>'
    +   '</div>'
    + '</div>';
}

function jcrHydrateOffer(typeKey, p) {
  var t = JCR_OFFERS[typeKey];
  var unlock = document.getElementById(t.unlockId);
  if (!unlock) return Promise.resolve();

  var img   = unlock.querySelector(typeKey === 'reward1' ? '.j_cr-reward1-img' : (typeKey === 'reward2' ? '.j_cr-reward2-img' : '.j_cr-reward3-img'));
  var msgEl = unlock.querySelector(t.msgClass);
  var wrap  = unlock.querySelector(t.wrapClass);
  var btn   = unlock.querySelector(t.btnClass);

  if (!p) {
    if (img) { img.removeAttribute('src'); img.alt = ''; }
    if (msgEl) msgEl.textContent = '';
    if (wrap) wrap.innerHTML = '';
    if (btn)  btn.dataset.variantId = '';
    return Promise.resolve();
  }

  if (img) {
    if (p.image) { img.src = p.image; img.alt = p.title || ''; }
    else { img.removeAttribute('src'); img.alt = ''; }
  }

  if (typeKey === 'reward1') {
    var meta = jcrGetReward1Meta();
    var finalPrice = meta.auto ? Number(p.price) : jcrDiscountedCents(p.price, meta.percent);
    var compareAt  = meta.auto ? Number(p.compare_at_price || 0) : Number(p.price);
    if (msgEl) msgEl.innerHTML = jcrRenderMessage(meta.text, p.title, Number(p.price), finalPrice, meta.percent, compareAt);
    return jcrHydrateVariantSelect(p, wrap, btn, msgEl).then(function(){
      if (btn && !btn.dataset.properties) btn.dataset.properties = JSON.stringify({ _reward1: '1', _source: 'minicart' });
    });
  } else {
    var cfgArr = jcrRefs.cfg || [];
    var tplObj = null;
    for (var i = 0; i < cfgArr.length; i++) { if (cfgArr[i] && cfgArr[i].key === typeKey) { tplObj = cfgArr[i]; break; } }
    var tpl = (tplObj && tplObj.text) ? tplObj.text : '';
    jcrRenderPremiumLabelFor(unlock, tpl, p);
    return jcrHydrateVariantSelect(p, wrap, btn, null).then(function(){
      if (btn && !btn.dataset.properties) {
        var props = { _source: 'minicart' };
        if (typeKey === 'reward2') props._reward2 = '1';
        if (typeKey === 'reward3') props._reward3 = '1';
        btn.dataset.properties = JSON.stringify(props);
      }
    });
  }
}

function jcrShowOffer(typeKey, p) {
  var t = JCR_OFFERS[typeKey];
  var unlock = document.getElementById(t.unlockId);
  if (!unlock) return;
  var skeletonExists = !!document.getElementById(t.cardId);

  if (!p) {
    if (skeletonExists) jcrHydrateOffer(typeKey, null);
    else unlock.innerHTML = '';
    return;
  }
  if (skeletonExists) jcrHydrateOffer(typeKey, p);
  else { jcrRenderOfferCard(typeKey, p); jcrHydrateOffer(typeKey, p); }
}

/* ===== 9) REMOVERS ===== */
function jcrRemoveByKeys(keys) {
  if (!Array.isArray(keys) || !keys.length) return Promise.resolve();
  return Promise.all(keys.map(function (key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 0 })
    }).catch(function () { return null; });
  })).then(function(){});
}

var __removingR1 = false;
function jcrRemoveReward1Items(cart) {
  if (__removingR1) return Promise.resolve();
  var keys = jcrCollectFlaggedKeys(cart, jcrIsReward1Line);
  if (!keys.length) return Promise.resolve();
  __removingR1 = true;
  return jcrRemoveByKeys(keys)
    .then(function(){ return jcrGetCart().catch(function(){ return null; }); })
    .then(function (latest) {
      if (latest) {
        var remaining = jcrCollectFlaggedKeys(latest, jcrIsReward1Line);
        if (remaining.length) return jcrRemoveByKeys(remaining);
      }
    })
    .then(function(){
      jcrEmitCartSignals({ removed: 'reward1', count: keys.length, source: 'jcrRemoveReward1Items' });
      document.dispatchEvent(new Event('cart:updated'));
    })
    .finally(function(){ __removingR1 = false; });
}

var __removingR23 = false;
function jcrRemoveReward2or3Items(cart) {
  if (__removingR23) return Promise.resolve();
  var keys = jcrCollectFlaggedKeys(cart, jcrIsReward2or3Line);
  if (!keys.length) return Promise.resolve();
  __removingR23 = true;
  return jcrRemoveByKeys(keys)
    .then(function(){ return jcrGetCart().catch(function(){ return null; }); })
    .then(function (latest) {
      if (latest) {
        var remaining = jcrCollectFlaggedKeys(latest, jcrIsReward2or3Line);
        if (remaining.length) return jcrRemoveByKeys(remaining);
      }
    })
    .then(function(){
      jcrEmitCartSignals({ removed: 'reward2/3', count: keys.length, source: 'jcrRemoveReward2or3Items' });
      document.dispatchEvent(new Event('cart:updated'));
    })
    .finally(function(){ __removingR23 = false; });
}

/* ===== 10) MAIN REFRESH ===== */
var __r23BelowCount = 0;
window.__jcrReward1Claiming = false;

var __jcrReward1ClaimingTimer = null;
function jcrStartClaimLock(ms) { if (typeof ms !== 'number') ms = 8000; window.__jcrReward1Claiming = true; if (__jcrReward1ClaimingTimer) clearTimeout(__jcrReward1ClaimingTimer); __jcrReward1ClaimingTimer = setTimeout(function () { window.__jcrReward1Claiming = false; }, ms); }
function jcrStopClaimLock() { window.__jcrReward1Claiming = false; if (__jcrReward1ClaimingTimer) { clearTimeout(__jcrReward1ClaimingTimer); __jcrReward1ClaimingTimer = null; } }

var __jcrLastRefreshAt = 0;

function refreshBar() {
  var now = Date.now();
  if (now - __jcrLastRefreshAt < 120) return; // throttle burst refreshes
  __jcrLastRefreshAt = now;
  jcrInitRefs(true);
  var bar = jcrRefs.bar;
  if (!bar) return;

  if (!bar.querySelector('.j_cr-marker')) jcrBuildUIFromConfig();
  jcrPositionMarkers(bar);

  var cartPromise = jcrGetCart();
  cartPromise.then(function (cart) {
    var total = jcrGetSpendSubtotal(cart);

    jtrace('refreshBar: item_count=', cart.item_count, 'subtotal(excl rewards)=', total);

    var containerEl = jcrRefs.container;
    if (containerEl) {
      var hasItems = (cart.item_count || 0) > 0;
      containerEl.classList.toggle('is-hidden', !hasItems);
    }

    var fill    = bar.querySelector('.j_cr-fill');
    var markers = Array.prototype.slice.call(bar.querySelectorAll('.j_cr-marker'));
    if (!fill || !markers.length) { jtrace('no fill/markers'); return; }

    var marks = markers.map(function (m) {
      return { t: parseInt(m.dataset.threshold || '0', 10) || 0, pos: parseFloat(m.dataset.pos || '0') || 0 };
    }).sort(function (a, b) { return a.pos - b.pos; });

    var widthPct = Math.max(0, Math.min(100, jcrComputeFillPct(total, marks)));
    jcrSetFillScale(fill, widthPct);

    var labels = (jcrRefs.container || document).querySelectorAll('.j_cr-label');
    for (var i = 0; i < markers.length; i++) {
      var m = markers[i];
      var t = parseInt(m.dataset.threshold || '0', 10) || 0;
      var reached = total >= t && t > 0;
      if (labels[i]) labels[i].classList.toggle('is-reached', reached);

      var key = m.dataset.key || '';
      var nextState = reached ? 'met' : 'default';
      var prevState = m.dataset.state || __jcrMarkerState[key];
      if (prevState !== nextState) {
        if (key === 'free_shipping') {
          m.classList.toggle('is-reached', reached);
          var amt = m.querySelector('.j_cr-amt');
          var img = m.querySelector('.j_cr-icon');
          if (reached) { if (amt) amt.style.display = 'none'; if (img) img.style.display = ''; }
          else { if (amt) amt.style.display = ''; if (img) img.style.display = 'none'; }
        } else {
          var icon = m.querySelector('.j_cr-icon');
          if (icon) {
            var defSrc = icon.getAttribute('data-default-icon') || '';
            var metSrc = icon.getAttribute('data-met-icon') || '';
            icon.src = reached && metSrc ? metSrc : defSrc;
          }
        }
        m.dataset.state = nextState;
        __jcrMarkerState[key] = nextState;
      }
    }

    // Resolve config items by key
    var data = jcrGetCfgAndRewardsCached();
    var cfg  = data.cfg;

    function findCfg(key) {
      for (var i = 0; i < cfg.length; i++) { if (cfg[i] && cfg[i].key === key) return cfg[i]; }
      return null;
    }

    var r1Cfg = findCfg('reward1');
    var r2Cfg = findCfg('reward2');
    var r3Cfg = findCfg('reward3');

    var meetsR1 = !!(r1Cfg && total >= Number(r1Cfg.amount || 0));
    var meetsR2 = !!(r2Cfg && total >= Number(r2Cfg.amount || 0));
    var meetsR3 = !!(r3Cfg && total >= Number(r3Cfg.amount || 0));

    jtrace('thresholds:',
      'R1:', r1Cfg ? (r1Cfg.amount + ' (met=' + meetsR1 + ')') : '—',
      'R2:', r2Cfg ? (r2Cfg.amount + ' (met=' + meetsR2 + ')') : '—',
      'R3:', r3Cfg ? (r3Cfg.amount + ' (met=' + meetsR3 + ')') : '—');

    /* reward2 / reward3 handler */
    function handleR(key, flagName, unlockEl, listRaw, meets) {
      jtrace('handleR start →', key, 'flag=', flagName, 'meets=', meets, 'unlock?', !!unlockEl, 'rawListLen=', (listRaw||[]).length);
      if (!unlockEl) return Promise.resolve();

      function hidePanel() {
        jcrRenderPremiumLabelFor(unlockEl, '', null);
        jcrShowOffer(key, null);
        unlockEl.classList.remove('is-visible');
        jcrHideSection(unlockEl);
      }

      if (!meets) {
        var hasAny = jcrCollectFlaggedKeys(cart, jcrIsReward2or3Line).length > 0;
        if (hasAny) {
          jtrace('handleR', key, 'below threshold → removing existing reward2/3 lines');
          // NEW (surgical — only this tier)
          return jcrRemoveTierItems(cart, flagName, 'handleR:below')
            .then(hidePanel)
            .then(function(){ jtrace('handleR', key, 'done below: hidden'); });
        }
        hidePanel();
        jtrace('handleR', key, 'below: nothing to remove, hidden');
        return Promise.resolve();
      }

      var list = jcrNormalizeOfferList(Array.isArray(listRaw) ? listRaw : []);
      var tierAlreadyInCart = (cart.items || []).some(function (i) {
        var p = i.properties || {};
        return p[flagName] === 1 || p[flagName] === '1' || p[flagName] === true || p[flagName] === 'true';
      });

      jtrace('handleR', key, 'normalized list len=', list.length, 'tierAlreadyInCart=', tierAlreadyInCart);

      if (!list.length || tierAlreadyInCart) {
        hidePanel();
        jtrace('handleR', key, 'hidden because', (!list.length ? 'no list' : 'already in cart'));
        return Promise.resolve();
      }

      var allowCollision = !jcrGetTierAuto(key); // auto=false → allow same-SKU rewards
      return jcrPickOffer(cart, list, key, allowCollision).then(function (res) {
        jtrace('handleR', key, 'pick result:', res && res.pick ? ('picked ' + (res.pick.handle||res.pick.variant_id)) : 'no pick');
        if (!res.pick) { hidePanel(); jtrace('handleR', key, 'no pick → hidden'); return; }

        var cfgArr = jcrRefs.cfg || [];
        var tplObj = null;
        for (var i = 0; i < cfgArr.length; i++) { if (cfgArr[i] && cfgArr[i].key === key) { tplObj = cfgArr[i]; break; } }
        var tpl = (tplObj && tplObj.text) ? tplObj.text : '';

        jcrRenderPremiumLabelFor(unlockEl, tpl, res.pick);
        jcrShowOffer(key, res.pick);
        jcrShowSection(unlockEl);
        unlockEl.classList.add('is-visible');
        jtrace('handleR', key, 'shown');
      }).catch(function (e) {
        jlog('error', 'handleR error for ' + key, e);
        hidePanel();
      });
    }



    return Promise.resolve()
      .then(function(){ return handleR('reward2', '_reward2', jcrRefs.unlockR2, jcrRefs.reward2Data, meetsR2); })
      .then(function(){ return handleR('reward3', '_reward3', jcrRefs.unlockR3, jcrRefs.reward3Data, meetsR3); })
      .then(function(){
        // Reward 1
        var unlockR1 = jcrRefs.unlockR1;
        if (!unlockR1) { jtrace('R1 unlock missing'); return; }

        if (!meetsR1) {
          jtrace('R1 below threshold → remove/hide');
          jcrRemoveReward1Items(cart).catch(function(){});
          jcrShowOffer('reward1', null);
          unlockR1.classList.remove('is-visible');
          jcrHideSection(unlockR1);
          return;
        }
        if (window.__jcrReward1Claiming) {
          jtrace('R1 claim lock active → hide');
          jcrShowOffer('reward1', null);
          unlockR1.classList.remove('is-visible');
          jcrHideSection(unlockR1);
          return;
        }
        var r1List = jcrNormalizeOfferList(jcrRefs.reward1Data || []);
        jtrace('R1 normalized list len=', r1List.length);
        if (!r1List.length) {
          jcrShowOffer('reward1', null);
          unlockR1.classList.remove('is-visible');
          jcrHideSection(unlockR1);
          jtrace('R1 hidden: no list');
          return;
        }
        jcrPickOffer(cart, r1List, 'reward1', !jcrGetTierAuto('reward1')).then(function(pickRes){
          jtrace('R1 pick result:', pickRes && pickRes.pick ? ('picked ' + (pickRes.pick.handle||pickRes.pick.variant_id)) : 'no pick');
          if (pickRes.anyFlaggedInCart || !pickRes.pick) {
            jcrShowOffer('reward1', null);
            unlockR1.classList.remove('is-visible');
            jcrHideSection(unlockR1);
            jtrace('R1 hidden: already flagged or no pick');
            return;
          }
          jcrShowOffer('reward1', pickRes.pick);
          unlockR1.classList.add('is-visible');
          jcrShowSection(unlockR1);
          jtrace('R1 shown');
        });
      });

  }).catch(function(e){
    jlog('error', 'refreshBar failed', e);
  });
}

/* ===== 11) UPSELL SLIDER + SECTION REFRESH ===== */
function __upsellFetchJSON(url, options) {
  return fetch(url, Object.assign({ credentials: 'same-origin' }, options || {}))
    .then(function(res){ if (!res.ok) throw new Error(res.status + ' ' + res.statusText); return res.json(); });
}
function __upsellSetHTML(el, html) { if (el) el.innerHTML = html == null ? '' : String(html); }

function initUpsellSlider() {
  var slider = document.querySelector('.j_cart-upsell__slider');
  if (!slider) return;
  var track = slider.querySelector('.j_cart-upsell__track');
  var prev = slider.querySelector('.j_cart-upsell__prev');
  var next = slider.querySelector('.j_cart-upsell__next');

  if (prev && prev.parentNode) {
    prev.parentNode.replaceChild(prev.cloneNode(true), prev);
    prev = slider.querySelector('.j_cart-upsell__prev');
    prev.addEventListener('click', function () { if (track) track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    prev.setAttribute('aria-label', 'Scroll upsells left');
  }
  if (next && next.parentNode) {
    next.parentNode.replaceChild(next.cloneNode(true), next);
    next = slider.querySelector('.j_cart-upsell__next');
    next.addEventListener('click', function () { if (track) track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    next.setAttribute('aria-label', 'Scroll upsells right');
  }
}

function refreshUpsells() {
  var container = document.querySelector('#CartUpsell');
  if (!container) return;
  container.classList.add('is-updating');
  __upsellFetchJSON('/?sections=mini_cart').then(function(data){
    var html = data.mini_cart || (data.sections && data.sections.mini_cart);
    if (!html) throw new Error('mini_cart section missing');

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newUps = doc.querySelector('#CartUpsell');
    if (newUps) {
      var has = newUps.querySelector('.j_cart-upsell__item');
      __upsellSetHTML(container, has ? newUps.innerHTML : '');
      container.style.display = has ? '' : 'none';
      if (has) initUpsellSlider();
    }
  }).catch(function(e){
    jlog('error', 'refreshUpsells failed', e);
  }).finally(function(){
    container.classList.remove('is-updating');
  });
}

var __jcrSectionInflight = false;
function refreshMiniCartSection() {
  if (__jcrSectionInflight) return Promise.resolve();
  __jcrSectionInflight = true;
  return __upsellFetchJSON('/?sections=mini_cart').then(function(data){
    var html = data && (data.mini_cart || (data.sections && data.sections.mini_cart));
    if (!html) return;

    var wrapper =
      document.getElementById('shopify-section-mini_cart') ||
      document.querySelector('#shopify-section-mini_cart');

    if (wrapper) {
      wrapper.innerHTML = html;
    } else {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var currentSel = ['[data-mini-cart]', '#mini-cart', '[data-section-type="mini_cart"]'];
      var freshSel   = ['[data-mini-cart]', '#mini-cart', '[data-section-type="mini_cart"]'];
      var current = null, fresh = null, i;
      for (i = 0; i < currentSel.length; i++) { current = document.querySelector(currentSel[i]); if (current) break; }
      for (i = 0; i < freshSel.length; i++) { fresh = doc.querySelector(freshSel[i]); if (fresh) break; }
      if (current && fresh) current.innerHTML = fresh.innerHTML;
    }

    jcrInitRefs(true);
    jcrBuildUIFromConfig();
    refreshBar();
    initUpsellSlider();
  }).catch(function(e){
    jlog('error', 'refreshMiniCartSection failed', e);
  }).finally(function(){
    __jcrSectionInflight = false;
  });
}

/* ===== 12) LIFECYCLE & EVENTS ===== */
document.addEventListener('DOMContentLoaded', function () {
  jlog('info', 'DOMContentLoaded');
  jcrInitRefs();
  jcrBuildUIFromConfig();
  refreshBar();
  initUpsellSlider();

  // Quick Add (reward1/2/3): always manual add
  document.body.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.j_cart-upsell__quickadd');
    if (!btn) return;

    var u1 = document.getElementById('j_cr-reward1-unlock');
    var u2 = document.getElementById('j_cr-reward2-unlock');
    var u3 = document.getElementById('j_cr-reward3-unlock');
    var insideR1 = !!(u1 && u1.contains(btn));
    var insideR2 = !!(u2 && u2.contains(btn));
    var insideR3 = !!(u3 && u3.contains(btn));
    if (!insideR1 && !insideR2 && !insideR3) return;

    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();

    var prevDisabled = btn.disabled;
    btn.disabled = true;
    if (insideR1) jcrStartClaimLock();

    var props = insideR1 ? { _reward1: '1', _source: 'minicart' }
             : insideR2 ? { _reward2: '1', _source: 'minicart' }
                        : { _reward3: '1', _source: 'minicart' };

    var formEl = btn.closest('form');
    var idInput = formEl && formEl.querySelector('input[name="id"]');
    var variantId = btn.dataset.variantId || (idInput && idInput.value);

    if (!variantId) { btn.disabled = prevDisabled; if (insideR1) jcrStopClaimLock(); return; }

    jcrManualAddWithProps(variantId, props)
      .then(function(){
        document.dispatchEvent(new Event('cart:updated'));
        return refreshMiniCartSection();
      })
      .catch(function(err){ jlog('error', 'QuickAdd flow failed', err); })
      .finally(function(){
        if (insideR1) jcrStopClaimLock();
        btn.disabled = prevDisabled;
      });
  }, true);

});
// === CART EVENT LISTENERS (DEDUPED) ===
var __jcrListenersAttached = false;

(function attachMoreCartListeners(){
  if (__jcrListenersAttached) return;
  __jcrListenersAttached = true;

  var names = [
    'cart:updated','cart:change','cart:refresh',
    't4s:cart:updated','t4s:cart:change',
    'ajaxCart:updated','ajaxProduct:added',
    'added.ajaxProduct','removed.ajaxProduct'
  ];

  names.forEach(function(n){
    document.addEventListener(n, function(){
      jcrDebouncedRefresh(100);
      if (n === 'cart:updated' || n === 'ajaxCart:updated' || n === 'added.ajaxProduct' || n === 'removed.ajaxProduct') {
        refreshUpsells();
      }
    }, { passive: true });
  });
})();


/* ===== 13) DIAGNOSTIC INSPECTOR ===== */
window.__jcrDiag = function(){
  var info = {
    cfg: jcrRefs.cfg,
    reward1: jcrRefs.reward1Data,
    reward2: jcrRefs.reward2Data,
    reward3: jcrRefs.reward3Data,
    unlocks: {
      r1: !!jcrRefs.unlockR1,
      r2: !!jcrRefs.unlockR2,
      r3: !!jcrRefs.unlockR3
    }
  };
  console.log('[JCR:DIAG]', info);
  return info;
};

/*******  END *******/
